import React from "react";
import WorkshopSidebarWrap from "./WorkshopSidebarWrap";

function AllWorkshops() {
  
  return (
    <>
      <WorkshopSidebarWrap />
    </>
  );
}

export default AllWorkshops;
